export const URUGUAY_STATES = [
  'Artigas',
  'Canelones',
  'Cerro Largo',
  'Colonia',
  'Durazno',
  'Flores',
  'Florida',
  'Lavalleja',
  'Maldonado',
  'Montevideo',
  'Paysandú',
  'Río Negro',
  'Rivera',
  'Rocha',
  'Salto',
  'San José',
  'Soriano',
  'Tacuarembó',
  'Treinta y Tres',
];

export const URUGUAY_CITIES: Record<string, string[]> = {
  Artigas: ['Artigas', 'Bella Unión'],
  Canelones: ['Canelones', 'Las Piedras', 'Pando', 'Atlántida'],
  'Cerro Largo': ['Melo', 'Río Branco'],
  Colonia: ['Colonia del Sacramento', 'Carmelo', 'Nueva Helvecia'],
  Durazno: ['Durazno', 'Sarandí del Yí'],
  Flores: ['Trinidad'],
  Florida: ['Florida', 'Sarandí Grande'],
  Lavalleja: ['Minas'],
  Maldonado: ['Maldonado', 'Punta del Este', 'San Carlos', 'Piriápolis'],
  Montevideo: ['Montevideo'],
  Paysandú: ['Paysandú', 'Guichón'],
  'Río Negro': ['Fray Bentos', 'Young'],
  Rivera: ['Rivera', 'Tranqueras'],
  Rocha: ['Rocha', 'Chuy', 'Castillos', 'La Paloma'],
  Salto: ['Salto', 'Belén'],
  'San José': ['San José de Mayo', 'Ciudad del Plata'],
  Soriano: ['Mercedes', 'Dolores', 'Cardona'],
  Tacuarembó: ['Tacuarembó', 'Paso de los Toros'],
  'Treinta y Tres': ['Treinta y Tres', 'Vergara'],
};




